import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import '../styles/main-page.scss';

const SocialListeningHeader = ({ rightSection }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <div className="sl-main-page-header">
      <div className="sl-main-page-header-left">
        <HeaderItem
          text="Campaigns"
          isSelected={pathname.includes('campaigns')}
          onClick={() => navigate('/dashboard/social/campaigns')}
        />
        <div className="sl-main-page-header-divider" />
        <HeaderItem
          text="Libraries"
          isSelected={pathname.includes('libraries')}
          onClick={() => navigate('/dashboard/social/libraries')}
        />
      </div>
      <div className="sl-main-page-header-right">{rightSection}</div>
    </div>
  );
};

const HeaderItem = ({ isSelected, text, onClick, right }) => {
  return (
    <div
      className={`sl-main-page-header-item ${isSelected ? 'sl-main-page-header-item-selected' : ''}`}
      onClick={onClick}>
      {text}
      {right}
    </div>
  );
};

export default SocialListeningHeader;
